// src/pages/auth/SignUp.js
// For new user 
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useMainPageTitle } from "../../contexts/PageContext";
import SignUpForm from "../../components/pages/auth/SignupForm";
import GoogleBtn from "./components/googleBtn";
import { Link } from "react-router-dom";

export default function SignUp() {
  const { t } = useTranslation();
  const { updatePageTitle } = useMainPageTitle();

  useEffect(() => {
    updatePageTitle(t("auth.signUp"), t("auth.createAccount"));
  }, [updatePageTitle, t]);

  /**
   * Handle successful Google registration
   * Called when Google signup completes successfully
   */
  const handleGoogleSuccess = () => {
    console.log("Google sign-up successful");
    // Navigation is handled by the GoogleBtn component
  };

  /**
   * Handle Google registration error
   * Called when Google signup fails
   */
  const handleGoogleError = (error) => {
    console.error("Google sign-up error:", error);
    // Error display is handled by the GoogleBtn component
  };

  return (
    <div className="max-w-6xl mx-auto signin">
      {/* Main Content Grid */}
      <div className="grid lg:grid-cols-2 gap-8 lg:gap-12">
        
        {/* Sign Up Form Section */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-6 lg:p-8">
          <div className="mb-6">
            <h2 className="text-2xl font-bold text-gray-800 mb-2">{t("auth.createAccount")}</h2>
            <p className="text-gray-600">{t("auth.joinThousands")}</p>
          </div>
          <SignUpForm />
        </div>

        {/* Alternative Options Section */}
        <div className="space-y-6">
          
          {/* Google Sign Up */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-6 lg:p-8">
            <h3 className="text-xl font-semibold text-gray-800 mb-4 text-center">
              {t("auth.quickSignIn")}
            </h3>
            <div className="flex justify-center">
              <GoogleBtn
                text={t("auth.signUp") + " " + t("auth.signInWithGoogle").toLowerCase()}
                onSuccess={handleGoogleSuccess}
                onError={handleGoogleError}
                className="w-full max-w-sm"
              />
            </div>
          </div>

          {/* Sign In Option */}
          <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-lg border border-blue-100 p-6 lg:p-8">
            <h3 className="text-xl font-semibold text-gray-800 mb-4 text-center">
              {t("auth.alreadyHaveAccount")}
            </h3>
            <p className="text-gray-600 text-center mb-6">
              {t("auth.welcomeBack")}! {t("auth.loginToAccount")}
            </p>
            <div className="flex justify-center">
              <Link
                to="/signin"
                className="bg-[#F15213] hover:bg-[#F15213]/90 text-white font-semibold px-8 py-3 rounded-lg transition-colors shadow-md hover:shadow-lg"
              >
                {t("auth.signIn")}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
